export default "__VITE_ASSET__B4fn7YZj__"